import React, { useState } from "react";

const RejectModal = ({ show, onClose, onConfirm, message }) => {
  const [remark, setRemark] = useState("");

  const handleConfirm = () => {
    onConfirm(remark); // Pass the remark back to the parent
  };

  if (!show) return null;

  return (
    <>
      <div className="modal fade show d-block">
        <div className="d-flex justify-content-center align-items-center vh-100">

          <div className="modal-container">
            <p>{message || "Are you sure?"}</p>

            <div className="modal-remark">
              <label htmlFor="remark">Remark:</label>
              <textarea
                id="remark"
                rows="4"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder="Add your remark here..."
              ></textarea>
            </div>

            <div className="modal-actions">
              <button className="confirm-btn w-25" onClick={handleConfirm}>Yes</button>
              <button className="cancel-btn w-25" onClick={onClose}>No</button>
            </div>
          </div>
        </div>

      </div>

      <style>
        {`
          .modal-overlay {
            position: fixed;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 1000;
          }
          .modal-container {
            background: #fff;
            padding: 40px 20px;
            border-radius: 8px;
            width: 400px;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
            text-align: center;
            margin-bottom:5%;

          }
            body[data-layout-mode="dark"] .modal-container {
            background: #2e2e2e;
  }
            .modal-container p{
            font-size: 19px;
            font-weight:400;
            }
          .modal-remark {
            margin-top: 15px;
            text-align: left;
          }
          .modal-remark textarea {
            width: 100%;
            padding: 10px;
            margin-top: 5px;
            border: 1px solid #ccc;
            border-radius: 4px;
          }
            body[data-layout-mode="dark"] .modal-remark textarea {
            background: #2e2e2e;
            color:#fff;
            }
          .modal-actions {
            margin-top: 20px;
            display: flex;
            justify-content: space-around;
          }
          .confirm-btn {
            background: #4caf50;
            color: white;
            padding: 10px 20px;
            border: none;
            border-radius: 4px;
            cursor: pointer;
          }
          .confirm-btn:hover {
            background: #45a049;
          }
          .cancel-btn {
            background: #f44336;
            color: white;
            padding: 10px 20px;
            border: none;
            border-radius: 4px;
            cursor: pointer;
          }
          .cancel-btn:hover {
            background: #e53935;
          }
        `}
      </style>
    </>

  );
};

export default RejectModal;
